import {
  ApiServiceSettingsApi,
  useApiServiceSettingsAPI,
} from "melco-shared-logic";
import { useCallback } from "react";
import { BasicSettingsResult } from "./useBasicSettings";

const initialValue = { settings: undefined };

export const useApiServiceBasicSettings = () => {
  const handleRequest = useCallback(async (api: ApiServiceSettingsApi) => {
    const {
      default_embroidery_production_file_format,
      measurement_unit,
      enable_production_links,
    } = await api.accountProductSettingsGetApiServiceAppSetting();

    return {
      settings: {
        default_embroidery_production_file_format,
        measurement_unit,
        enable_production_links,
      },
    };
  }, []);

  return useApiServiceSettingsAPI<BasicSettingsResult>({
    initialValue,
    handleRequest,
  });
};
